// Modules
import React from "react";

function AccordionMenu({
  link,
  hasIcon,
  onRowClicked,
  onToggle,
  PageLevel = 0,
  SubLevel = 0,
  Icon,
  label,
  wrapperStyles,
  labelStyles,
}) {
  if (link?.includes("pdf")) {
    return (
   <div
   className={`w-full p-5 flex justify-between ${wrapperStyles}`}
   >
	   <a
        href="/pdf/Telecel _Cash_Privacy_Statement_2024.pdf"
        download="Telecel _Cash_Privacy_Statement_2024.pdf"
        target="_blank"
		// className={`w-full p-5 flex justify-between ${wrapperStyles}`}
		className= "text-body_sm font-semibold text-white "
      >
        {label}
      </a>
   </div>
    );
  }
  // render icon if children has a length > 0
  // except hamburger Icon
  return (
    <div
      className={`w-full p-5 flex justify-between ${wrapperStyles}`}
      onClick={onRowClicked}
    >
      <div className={labelStyles}>{label}</div>
      <div>{hasIcon && <button onClick={onToggle}>{Icon}</button>}</div>
    </div>
  );
}

// Export
export default AccordionMenu;
